import React, { useState, useEffect } from "react";
import { Row, Col, Typography, Input, Checkbox } from "antd";
import { capitalize } from "utils/randomString";
import { useTracking } from "react-tracking";
import {
  SEARCH_KEYWORD_BUYERS,
  FILTER_SELECT_COUNTRY,
  FILTER_DESELECT_COUNTRY,
  FILTER_SELECT_HS_CODE,
  FILTER_DESELECT_HS_CODE,
} from "../../../../analytics/events";
import { MdClose, MdSearch } from "react-icons/md";
import "./filters.css"
const { Title, Text } = Typography;
export default function Filters({
  countries,
  setSelectedCountries,
  setSelectedProducts,
  selectedCountries,
  setQuery,
  setSelectedHsCode,
  hsCodesData,
  selectedHsCode,
}) {
  const [search, setSearch] = useState("");
  const { trackEvent } = useTracking();

  const [filteredCountries, setFilteredCountries] = useState([]);
  const [filteredHsCodes, setFilteredHsCodes] = useState(null);

  useEffect(() => {
    if (countries && countries.length) {
      setFilteredCountries(countries);
    }
  }, [countries]);

  useEffect(() => {
    if (hsCodesData && hsCodesData.length) {
      setFilteredHsCodes(hsCodesData);
    }
  }, [hsCodesData]);

  const onChangeCountry = (e, value) => {
    if (e.target.checked) {
      setSelectedCountries((state) => [value, ...state]);

      trackEvent({
        name: FILTER_SELECT_COUNTRY,
        meta: {
          filter_name: value,
        },
      });
    } else {
      setSelectedCountries((state) => state.filter((item) => item !== value));
      trackEvent({
        name: FILTER_DESELECT_COUNTRY,
        meta: {
          filter_name: value,
        },
      });
    }
  };

  const onChangeHsCode = (e, value) => {
    if (e.target.checked) {
      setSelectedHsCode((state) => [value, ...state]);

      trackEvent({
        name: FILTER_SELECT_HS_CODE,
        meta: {
          filter_name: value,
        },
      });
    } else {
      setSelectedHsCode((state) => state.filter((item) => item !== value));
      trackEvent({
        name: FILTER_DESELECT_HS_CODE,
        meta: {
          filter_name: value,
        },
      });
    }
  };

  const handleSearch = (e) => {
    setQuery(search);
    trackEvent({
      name: SEARCH_KEYWORD_BUYERS,
      meta: {
        keyword: search,
      },
    });
  };

  const handleFilterSearch = (type, value) => {
    if (type === "countries") {
      if (value.length > 1) {
        let found = countries.filter(
          (item) => item.key.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
        setFilteredCountries(found);
      } else {
        setFilteredCountries(countries.slice(0, 10));
      }
    } else if (type === "hs codes") {
      if (value.length > 1) {
        let found = hsCodesData.filter(
          (item) => item.key.toString().indexOf(value) !== -1
        );

        setFilteredHsCodes(found);
      } else {
        setFilteredHsCodes(hsCodesData.slice(0, 10));
      }
    }
  };

  const clearCoutries = (clear) => {
    if (clear) {
      setFilteredCountries(countries);
    }
  };
  const clearHsCodes = (clear) => {
    if (clear) {
      setFilteredHsCodes(hsCodesData);
    }
  };

  return (
    <Row
      style={{
        border: "1px solid #E6E7E7",
        marginRight: "1em",
        height: "100%",
        borderRadius: 4,
        padding: 20,
      }}
    >
      <Col span={24}>
        <Row>
          <Col span={24}>
            <Title level={5}>Filter</Title>
          </Col>
        </Row>

        {/* text search here */}
        <Row>
          <Col span={24}>
            <Input.Search
              size="middle"
              placeholder="Enter name of buyer or product"
              onChange={(e) => setSearch(e.target.value)}
              onSearch={handleSearch}
            ></Input.Search>
          </Col>
        </Row>

        {/* countries filter here */}
        <Row
          style={{
            marginTop: "3em",
            border: "1px solid #e8e8e8",
            borderRadius: 4,
            padding: 8,
          }}
          justify={"space-between"}
        >
          <Col span={24}>
            <Search
              filterName={"Countries"}
              count={countries?.length}
              handleFilterSearch={handleFilterSearch}
              clearCoutries={clearCoutries}
              
            />
          </Col>
          <Row
            style={{ marginTop: "1em", maxHeight: "40em", overflowY: "scroll" }}
          >
            {filteredCountries &&
              filteredCountries?.length > 0 &&
              filteredCountries?.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Checkbox
                      checked={selectedCountries.includes(item?.key)}
                      onChange={(e) => onChangeCountry(e, item?.key)}
                    >
                      {item.key && (
                        <Text style={{ fontSize: "1em" }}>
                          {capitalize(item?.key)}{" "}
                          {/* <Text type="secondary">({item?.doc_count})</Text> */}
                        </Text>
                      )}
                    </Checkbox>
                  </Col>
                );
              })}
          </Row>
        </Row>

        {/* hscodes filter here */}
        <Row
          style={{
            marginTop: "3em",
            border: "1px solid #e8e8e8",
            borderRadius: 4,
            padding: 8,
          }}
          justify={"space-between"}
        >
          <Col span={24}>
            <Search
              filterName={"HS Codes"}
              count={hsCodesData?.length}
              handleFilterSearch={handleFilterSearch}
              clearHsCodes={clearHsCodes}
            />
          </Col>
          <Row
            style={{ marginTop: "1em", maxHeight: "40em", overflowY: "scroll" }}
          >
            {filteredHsCodes &&
              filteredHsCodes?.length > 0 &&
              filteredHsCodes?.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Checkbox
                      checked={selectedHsCode.includes(`${item?.key}`)}
                      onChange={(e) => onChangeHsCode(e, `${item?.key}`)}
                    >
                      {item.key && (
                        <Text style={{ fontSize: "1em" }}>
                          {item?.key}
                          {/* <Text type="secondary"> ({item?.doc_count})</Text> */}
                        </Text>
                      )}
                    </Checkbox>
                  </Col>
                );
              })}
          </Row>
        </Row>
      </Col>
    </Row>
  );
}

// Search component
const Search = ({
  filterName,
  count,
  handleFilterSearch,
  clearCoutries,
  clearHsCodes,
}) => {
  const [showSearch, setShowSearch] = useState(false);
  const handleClose = (filterName) => {
    console.log("filter",filterName.toLowerCase())
    setShowSearch((state) => !state);
    if (filterName?.toLowerCase() === "countries") {
      clearCoutries(true);
    } else if (filterName.toLowerCase() === "hs codes") {
      clearHsCodes(true);
    }
  };
  return (
    <>
      {showSearch ? (
        <Input
          size="middle"
          placeholder="Search"
          addonAfter={
            <MdClose
              size={22}
              onClick={() => handleClose(filterName)}
              style={{ cursor: "pointer", color: "gray" }}
            />
          }
          onChange={(e) =>
            handleFilterSearch(filterName?.toLowerCase(), e.target.value)
          }
        />
      ) : (
        <Row justify="space-between" align="middle">
          <Col style={{ color: "gray" }}>
            {filterName}
          </Col>
          <Col>
            <MdSearch
              onClick={() => setShowSearch((state) => !state)}
              size={25}
              style={{ cursor: "pointer", color: "gray" }}
            />
          </Col>
        </Row>
      )}
    </>
  );
};
